import { createInjection } from '@/lib/createInjection';
import { ViewMode } from '@/models/johaisetsu/johaisetsuCommon';

interface JohaisetsuViewMode {
  viewMode: ViewMode;
}

const { provide, inject } = createInjection<ViewMode>('johaisetsuMap/useJohaisetsuViewMode');

export function provideJohaisetsuViewMode(viewMode: ViewMode): void {
  provide(viewMode);
}

export function useJohaisetsuViewMode(): JohaisetsuViewMode {
  const viewMode = inject() || 'realtime';

  return {
    viewMode,
  };
}
